import { useScrollToSection } from "@/hooks/useScrollToSection";

export const ScrollLink = ({ to, offset = 0, children, className }) => {
  const scrollToSection = useScrollToSection();

  return (
    <button onClick={() => scrollToSection(to, offset)} className={className}>
      {children}
    </button>
  );
};